<template>

  <div class="body">
    <div class="main-content">
      <div v-if="showpay" class="el-alert is-dark" :class="showpaycss" style="margin-bottom: 20px;padding-top: 30px;padding-bottom: 30px">
        <i class="el-alert__icon el-icon-warning is-big"></i>
        <div class="el-alert__content">
          <p class="el-alert__description" style="font-size: x-large">{{payinfor}}</p>
        </div>
      </div>
      <div class="rl-box fl">
        <div class="tit">
          <span class="gtjl-tit">通知公告</span>
          <a class="more-btn1 fr" href="javascript:void(0);" @click="openInforList('001')"></a>
          <a class="add-btn fr" href="javascript:void(0);" @click="addInfor('001')"></a>

        </div>

        <div class="account-panel-content">
          <ul class="zw-box" ref="wait" v-show="!gonggao">
            <img class="zw-db_icon" src="/static/img/icon/zw-db_icon.png" @error="imgError"/>
            <p><span class="zw-txt">暂无</span><span>公告</span></p>
          </ul>
          <ul class="tzgg-list" v-show="gonggao">
            <li v-for="notice in noticeData" class="item-first l"
                @click="lookDetails(notice.unitguid,'001')">
              <p style="line-height: 20px;padding-left: 5px;height: 30px;">

                <a href="javascript:void(0);">
                  <span class="tzgg-span" style="height: 30px;">{{(notice.title || "").substr(0, 20)}}</span>
                </a>
              </p>
              <p style="line-height: 20px;">
                <a href="javascript:void(0);">
                  <span style="white-space: normal;" class="tzgg-content">【{{(notice.adddate || "").substr(0, 10)}}】{{notice.inforcontent | contentfilter}}</span>

                </a>
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div class="middle-box fl">
        <div id="tab-1" class="list-tit">
          <el-menu :default-active="todoCode" style="display:contents;" mode="horizontal" id="tab" @select="todomenuChange">
            <el-menu-item index="100">待办事项</el-menu-item>
            <el-menu-item index="200">我启动的</el-menu-item>
            <el-menu-item index="300">我已处理</el-menu-item>
            <!--<el-menu-item index="400">已办结</el-menu-item>-->
          </el-menu>
          <div style="float: right">
            <span title="更多"><a class="more-btn fr" href="javascript:void(0);" @click="viewToDoList"></a></span>
          </div>
        </div>
        <div id="content-1" class="list-content">
          <ToDoDialog ref="ToDoDialog" @rebindToDo="rebindToDo" :defaulttodo="todoCode"></ToDoDialog>
          <Todolist ref="Todolist" :ToDopageSize="7" :ToDotableheight="335" :defaulttodo="todoCode"
                    :ShowHead="false" v-show="daiban" @afterBindTodo="afterBindTodo"
                    :layout="'total, prev, pager, next, jumper'"></Todolist>
          <ul class="zw-box" v-show="!daiban">
            <img class="zw-db_icon" src="/static/img/icon/zw-db_icon.png" @error="imgError"/>
            <p><span class="zw-txt">暂无</span><span>{{todoEmptyStr}}</span></p>
          </ul>
        </div>
      </div>
      <!--待办事项、我启动的、我已处理end-->

      <div class="gtjl-box fr">
        <div class="tit">
          <span class="gtjl-tit">内部邮件</span>
          <a class="search-btn fr" href="javascript:void(0);" @click="lookExchangeDetail('','',0,0)"></a>
          <a class="add-btn fr" href="javascript:void(0);" @click="addExchange"></a>
          <ExchangeEdit ref="ExchangeEdit" @bindExchangeList="bindExchangeList"></ExchangeEdit>
          <ExchangeDetail ref="ExchangeDetail" @bindExchangeList="bindExchangeList"></ExchangeDetail>

        </div>
        <ul class="zw-box" v-show="!gtjl">
          <img class="zw-db_icon" src="/static/img/icon/zw-db_icon.png" @error="imgError"/>
          <p><span class="zw-txt">暂无</span><span>内部邮件</span></p>
        </ul>
        <ul class="li-list" v-show="gtjl" v-for="exchange in exchangeData">
          <li @click="lookExchangeDetail(exchange.exchangeguid,exchange.unitguid,exchange.exstatus,exchange.feedbacktimes)">
            <img class="tx" :src="PhotoPre+exchange.senduguid + '/p.png'"
                 onerror="this.src='/static/img/icon/tx_icon1.png'" style="border-radius: 50%;"/>
            <p class="w-p">
              <span class="">{{exchange.senduname}}</span>
              <span class="color-999 fr">{{(exchange.senddate||"").substr(0, 10)}}</span>
            </p>
            <p class="w-p">
              <span
                class="news-text color-666">{{exchange.extitle}}</span>
              <span class="bandge" v-show="(exchange.feedbacktimes||0)>0">{{exchange.feedbacktimes}} </span>
            </p>
          </li>
        </ul>
      </div>
      <div class="line-15 clearLeft"></div>
      <!--沟通交流 end-->
      <div class="cyzl-box">
        <div class="tit">
          <span class="gtjl-tit">常用资料</span>
          <a class="more-btn1 fr" href="javascript:void(0);" @click="openInforclass('')"></a>
          <a class="add-btn fr" href="javascript:void(0);" @click="openInforclass('')"></a>
        </div>
        <ul class="zw-box" style="top:20px;" v-show="!cyzl">
          <img class="zw-db_icon" src="/static/img/icon/zw-db_icon.png" @error="imgError"/>
          <p><span class="zw-txt">暂无</span><span>常用资料</span></p>
        </ul>
        <ul class="cyzl_list" v-show="cyzl" v-for="inforclass in inforclassData">
          <li style="padding-top: 10px">
            <a href="javascript:void(0);" @click="openInforclass(inforclass.classcode,inforclass.classname)">
              <img class="zjzx_icon" :src="'/static/img/icon_info/'+inforclass.attguid"/><br/>
              <span>{{inforclass.classname}}</span>
            </a>
          </li>
        </ul>
      </div>
      <!--常用资料 end-->

      <div class="zxdd-box">
        <div class="tit">
          <span class="gtjl-tit">最新动态</span>
          <a class="more-btn1 fr" href="javascript:void(0);" @click="openInforList('002')"></a>
          <a class="add-btn fr" href="javascript:void(0);" @click="addInfor('002')"></a>
        </div>
        <div class="account-panel-content">
          <ul class="zw-box" ref="wait" style="top:30px;" v-show="!zxdt">
            <img class="zw-db_icon" src="/static/img/icon/zw-db_icon.png" @error="imgError"/>
            <p><span class="zw-txt">暂无</span><span>动态</span></p>
          </ul>
          <ul class="zxdt-list" id="dynamic" v-show="zxdt">
            <li v-for="dynamic in dynamicData" class="item-first l"
                @click="lookDetails(dynamic.unitguid,'002')">
              <a href="javascript:void(0);">
                <span class="sp-tit">{{ dynamic.title }}</span>
                <span class="sp-time">{{ dynamic.adddate.substr(5,11) }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!--最新动态 end-->
      <InforclassListDialog ref="InforClassList"></InforclassListDialog>
      <InforListDialog ref="InforListDialog" @bindInfoList="bindInfoList"></InforListDialog>
      <InforEdit ref="InforEdit" @bindInfoList="bindInfoList"></InforEdit>
      <InforDetail ref="InforDetail" @bindInfoList="bindInfoList"></InforDetail>
    </div>
    <ewmPay ref="ewmPay"></ewmPay>
    <JxcgooddetailAudit ref="JxcgooddetailAudit1" @bindGrid="todolost"></JxcgooddetailAudit>
  </div>
</template>
<script>
  import {getListData} from '@/api/oa/inforlist';
  import {getExchangeListData} from '@/api/oa/exchange';
  import InforEdit from '../oa/inforlist/InforEdit';
  import InforDetail from '../oa/inforlist/InforDetail';
  import InforListDialog from '../oa/inforlist/InforListDialog';
  import ExchangeEdit from '../oa/exchange/ExchangeEdit'
  import JxcgooddetailAudit from '../set/jxcgooddetail/JxcgooddetailAudit'
  import ExchangeDetail from '../oa/exchange/ExchangeDetail';
  import {getInforClassListData} from '@/api/oa/inforclass';
  import {goodswaitaudit,newGoods} from '@/api/set/jxcgooddetail';
  import ewmPay from './ewmPay';
  import InforclassListDialog from '../oa/inforclass/InforclassListDialog.vue';
  import Todolist from '../set/workflow/Todolist';
  import ToDoDialog from '../set/workflow/ToDoDialog';

  export default {
    inject: ["reload"],
    name: "Home",
    data() {
      return {
        showpay:false,
        showpaycss:'el-alert--error',
        payinfor:'',

        PhotoPre: '',
        gonggao: true,
        zxdt: true,
        gtjl: true,
        cyzl: true,
        activeIndex: "100",
        daiban: true,
        qidong: false,
        yichuli: false,
        dynamicData: [],
        noticeData: [],
        exchangeData: [],
        inforclassData: '',

        todoCode: "100",
        todoEmptyStr: "",
        daiban: false,
        fufeiinfo:'',
      };
    },
    methods: {
      wxPay(){
        this.$refs.ewmPay.show();
      },
      viewToDoList() {
        this.$refs.ToDoDialog.changeToDo(this.todoCode);
      },
      rebindToDo() {
        this.todomenuChange(this.todoCode, '');
      },
      todomenuChange(key, keyPath) {
        this.todoCode = key;
        if (this.todoCode == '100')
          this.todoEmptyStr = '需要我处理的';
        else if (this.todoCode == '200')
          this.todoEmptyStr = '我启动的';
        else if (this.todoCode == '300')
          this.todoEmptyStr = '处理过的';
        else if (this.todoCode == '400')
          this.todoEmptyStr = '已办结';

        this.$refs.Todolist.initData({
          handlename: "",//标题
          erpserial: "",//单号
          begindate: "",
          enddate: "",
          beginsearchnumber: "",
          endsearchnumber: "",
          menuguid: "",
          todo: key,
        });
      },
      afterBindTodo(tableData) {
        this.daiban = tableData.length > 0;
      },

      addInfor(classcode) {
        this.$refs.InforEdit.initForm();
        this.OpenDialog(classcode);
      },
      OpenDialog(classcode) {
        this.$refs.InforEdit.show(classcode);
      },
      openInforclass(classcode, classname) {
        this.$refs.InforClassList.show(classcode, classname);
      },
      addExchange() {
        this.$refs.ExchangeEdit.initForm();
        this.$refs.ExchangeEdit.show();
      },
      lookDetails(unitguid, classcode) {
        this.$refs.InforDetail.initData(unitguid, classcode);
      },
      lookExchangeDetail(exchangeguid, unitguid, exstatus, feedbacktimes) {
        this.$refs.ExchangeDetail.show(exchangeguid, unitguid, exstatus, feedbacktimes);
      },
      openInforList(classcode) {
        this.$refs.InforListDialog.show(classcode);
      },
      bindInfoList(classcode) {
        if (classcode == '002')
          this.bindDynamicList(classcode);
        else
          this.bindNoticeList(classcode);
      },
      bindDynamicList(classcode) {
        getListData({
          offset: 0,
          limit: 7,
          classcode: classcode,
          status: 2
        }).then(response => {
          this.dynamicData = response.data.obj.rows;
          if (this.dynamicData.length == 0) {
            this.zxdt = false;
          }else{
            this.zxdt=true
          }
        }).catch((error) => {

        });
      },
      bindNoticeList(classcode) {
        getListData({
          offset: 0,
          limit: 4,
          classcode: classcode,
          status: 2
        }).then(response => {
          this.noticeData = response.data.obj.rows;
          if (this.noticeData.length == 0)
            this.gonggao = false;
          else
            this.gonggao=true;
        }).catch((error) => {
        });
      },
      bindExchangeList(count) {
        getExchangeListData({
          offset: 0,
          limit: count,
          isdel: 0
        }).then(response => {
          this.exchangeData = response.data.obj.rows;
          if (this.exchangeData.length == 0)
            this.gtjl = false;
          else
            this.gtjl = true;
        }).catch((error) => {

        });
      },
      bindInforClass(count) {
        getInforClassListData({
          offset: 0,
          limit: count,
          cyzl: "003"
        }).then(response => {
          if (response.data.obj) {
            this.inforclassData = response.data.obj.rows;
            if (this.inforclassData.length == 0)
              this.cyzl = false;
          }
        }).catch((error) => {
        });
      }
    },
    filters: {
      contentfilter(value) {
        if (!value) return ''
        var preg = /<(.|\n)+?>/gi;
        value = value.replace(preg, '');
        if (value.length > 55)
          value = value.substr(0, 55) + "…"
        return value
      }
    },

    mounted() {
      this.bindDynamicList('002', '5');
      this.bindNoticeList('001', '3');
      this.bindExchangeList(7);
      this.bindInforClass(6);
      //个人信息
      var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      //多企业信息
      var tokenInfo = JSON.parse(localStorage.getItem("hpapi_tokenModel"));

      var curTime = new Date();
      for (let i in tokenInfo.tenantDO) {
        if (userinfo.tenantid == tokenInfo.tenantDO[i].unitguid) {
          var endtime = new Date(Date.parse(tokenInfo.tenantDO[i].enddatetime));
          var endStr=endtime.getFullYear()+'-'+(endtime.getMonth()+1)+'-'+endtime.getDate();
          if (endtime < curTime) {
            this.showpay = true;
            this.payinfor='您的系统使用授权 已到期（'+endStr+'），请及时续费！';
          }else{
            endtime.setDate(endtime.getDate()-14);//提前2周提醒
            if (endtime < curTime) {
              this.showpay = true;
              this.showpaycss = 'el-alert--warning';
              this.payinfor='您的系统使用授权 即将到期（'+endStr+'），请及时续费！';
            }
          }
        }
      }
      this.PhotoPre = tokenInfo.attviewpath + "/" + userinfo.tenantid + "/myphoto/";
      this.inforPhoto = tokenInfo.attviewpath + "/" + userinfo.tenantid + "/inforclass/";
    },
    components: {
      InforListDialog,
      InforEdit,
      InforDetail,
      ewmPay,
      ExchangeEdit,
      ExchangeDetail,
      InforclassListDialog,
      JxcgooddetailAudit,
      Todolist,
      ToDoDialog,
    }
  }
</script>
<style scoped>
  @import "../../../static/css/home.css";
  @import "../../../static/css/common/clear.css";

  .body {
    height: calc(100vh - 48px);
    line-height: 16px;
    text-align: left;
    display: -webkit-box;
    width: 100%;
    background-color: #ebebeb;
  }

  #app[data-v-04c2046b] {
    text-align: left;
  }

  .el-menu::after, .el-menu::before {
    display: contents;
  }

</style>



// WEBPACK FOOTER //
// src/components/index/Home.vue